<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card  v-can="'view-sales-quote'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['In-Draft','Live', 'Cancelled', 'Expired']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['from']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['to']"
                placeholder="Choose Date"
              />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
        <vx-card v-if="!is_on_create" class="pt-4">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'sales-quote-sheet'" :filters="filters"/>
              <vs-button v-can="'create-edit-sales-quote'" @click="onClickCreateNewOrder" class="mr-4" color="primary" type="filled">Create sales quote</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <!-- <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" /> -->
            <vs-table id="customer-product-orders-table" :hoverFlat="true" 
                      :max-items="(meta.per_page) ? meta.per_page : 10" v-can="'view-sales-quote'" 
                      :data="sales_quote_list" :sst="true" class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="10%">SALES QUOTE NUMBER</vs-th>
                <vs-th v-if="!customerId" width="10%">CUSTOMER</vs-th>
                <vs-th width="10%">CREATED DATE/TIME</vs-th>
                <vs-th width="10%">CREATED BY</vs-th>
                <vs-th>PRODUCT/FG</vs-th>
                <vs-th width="10%">ACCOUNT MANAGER</vs-th>
                <vs-th width="10%">SAMPLE ORDERS</vs-th>
                <vs-th width="10%">LAST SENT DATE</vs-th>
                <vs-th width="10%">STATUS</vs-th>
                <vs-th width="20%">ACTIONS</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td class="font-semibold text-primary" >
                    {{ data[indextr].quote_code}}
                  </vs-td>

                  <vs-td v-if="!customerId" class="" >
                    <HyperLink :id="data[indextr].customer_id" type="customer">
                      <span>
                      {{ data[indextr].customer_name}} <br>
                      {{ data[indextr].customer_account_number }}
                    </span>
                  </HyperLink>
                  </vs-td>

                  <vs-td>
                    {{ __dateTimeFormatter(data[indextr].created_at) }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].created_by }}
                  </vs-td>

                  <vs-td>
                    <span v-if="data[indextr].items.length > 1" class="text-primary">multiple items</span>
                    <template v-else>
                      <span v-for="(item, idx) in data[indextr].items" :key="item.id || idx">
                        <HyperLink :id="item.id" type="formulation">
                          <span>{{ item.product_code_name }}</span>
                        </HyperLink>
                        <span v-if="idx < data[indextr].items.length - 1">, </span>
                      </span>
                    </template>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].account_manager }}
                  </vs-td>

                  <vs-td>
                    <div
                      v-if="data[indextr].sample_order.length > 0"
                      v-for="(sample_order, index_order) in data[indextr].sample_order" :key="index_order">
                      <a v-on:click.prevent="onClickViewSampleOrder(sample_order.id)">{{sample_order.sample_order_code}}</a>
                    </div>
                    <div v-if="data[indextr].sample_order.length === 0">N/A</div>
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].last_email_quote_sent || 'N/A' }}
                  </vs-td>

                  <vs-td>
                    <div v-if="data[indextr].status.name === 'Expired'">Expired</div>
                    <v-select v-if="data[indextr].status.name !== 'Expired'" placeholder="" v-model="data[indextr].status.name" :append-to-body="true" :clearable="false"
                         :options="[
                          {key: 'In-Draft', value: 'in-draft'}, 
                          {key: 'Live', value: 'live'}, 
                          {key: 'Cancel', value: 'cancel'}, 
                          ]" class="w-64" name="hello" :reduce="option => option.value" label="key"
                         @input="onChangeStatus($event, data[indextr].id)"
                         ></v-select>

                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View Sales Quote" position="left">
                        <vs-button @click.stop="viewSalesQuote(data[indextr].id)"
                                   size="small" color="success" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip  class="ml-2" text="Edit Sales Quote" position="left"  v-if="data[indextr].status.name == 'In-Draft'">
                        <vs-button @click.stop="editSalesQuote(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Print Sales Quote" position="left">
                        <vs-button @click.stop="onClickPrintQuote(data[indextr].id,data[indextr].customer_id, data[indextr].quote_code)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-printer"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Email log" position="left">
                        <vs-button @click.stop="onClickViewSalesQuoteEmailLog(data[indextr].id, data[indextr].quote_code)"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-mail"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Send sales quote" position="left">
                        <vs-button @click.stop="salesQuoteSendCheck(data[indextr].id, data[indextr].customer_id, data[indextr].quote_code)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-send"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>
          </div>
        </vx-card>
      </div>
    </div>
    <customer-catalogue-list v-bind:customer_id="customerId" v-bind:sample_order_id="sampleOrderId" v-bind:account_currency="account_currency" v-on:back="refreshData($event)" v-if="is_on_create"/>
    <vs-prompt
      @cancel="customerId = ''"
      @accept="changeStatus"
      @close="activePrompt = false"
      :title="'Create sales quote'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <customer-dropdown
          v-on:onInput="onSelectCustomer"
          :selected_customer_data="customerId"
        />
<!--        <span>Select customer</span>-->
<!--        <v-select-->
<!--          :clearable="true" name="customerId" placeholder=""-->
<!--          v-model="customerId"-->
<!--          label="company_name"-->
<!--          :options="customer_list"-->
<!--          :reduce="option => option.id"-->
<!--          :dir="$vs.rtl ? 'rtl' : 'ltr'"/>-->
      </div>
    </vs-prompt>
    <vs-prompt
      @cancel="customer_email=''"
      @accept="onClickSendQuote"
      @close="activePrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activeEmailSelectPrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_users_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.job_title || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>
    <view-sales-quote-pop-up ref="viewSalesQuotePopUp"/>
    <view-sales-quote-email-log-pop-up ref="viewSalesQuoteEmailLogPopUp"/>
    <SalesQuotePrintView ref="salesQuotePrintView" @sendEmail="salesQuoteSendCheck"/>
  </div>
</template>

<script>
import CustomerCatalogueList from "@/views/pages/sales-quote/CustomerCatalogueList";
import {RepositoryFactory} from "@/repository/RepositoryFactory";
const CustomerRepository = RepositoryFactory.get('customer')
const DropDownRepository = RepositoryFactory.get('drop_down')
import vSelect from 'vue-select'
import router from "@/router";
import {defaultPagination, perPageList} from "@/constants/config";
import Filter from "@/mixins/filter";
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";
import ViewSalesQuotePopUp from "../../../components/popups/sales-quote/ViewSalesQuotePopUp";
import ViewSalesQuoteEmailLogPopUp from "@/components/popups/sales-quote/ViewSalesQuoteEmailLogPopUp";
import SalesQuotePrintView from "@/components/popups/pdf/SalesQuotePrintView.vue";
import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'

export default {
  name: "SalesQuoteList",
  data() {
    return {
      is_on_create: false,
      sales_quote_list: [],
      customer_list: [],
      customerId: '',
      account_currency: 'GBP',
      activePrompt: false,
      activeEmailSelectPrompt: false,
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      customer_users_list: [],
      customer_email: '',
      selected_quote_id: '',
      sales_quote_detail_popup_id:'',
      sampleOrderId: ''
    }
  },
  mixins: [Filter, ErrorMessages, SuccessMessage],
  components: {
    ViewSalesQuotePopUp,
    CustomerCatalogueList,
    ViewSalesQuoteEmailLogPopUp,
    'v-select': vSelect,
    CustomerDropdown,
    flatPickr,
    SalesQuotePrintView,
  },
  async mounted() {
    if(this.$route.query.customer_id) {
      this.customerId = this.$route.query.customer_id
      this.sampleOrderId = this.$route.query.sample_order_id
      this.is_on_create = true
      router.push('/pages/sales-quote')
    }
    if(this.$route.query.id) {
      this.sales_quote_detail_popup_id = this.$route.query.id
      this.viewSalesQuote(this.sales_quote_detail_popup_id)
      router.push('/pages/sales-quote')
    }
    if(this.$route.params.id) {
      this.customerId = this.$route.params.id ? this.$route.params.id : null
    }
    await this.fetchSalesQuoteList()
  },
  methods: {
    async onClickCreateNewOrder() {
      if(this.$route.params.id) {
        this.is_on_create = true
      } else {
        await this.fetchCustomerList()
        this.activePrompt = true
      }

      // await this.fetchCustomerList()
    },
    async salesQuoteSendCheck(quote_id, customer_id, quote_code) {
      const email_log = await this.fetchEmailLog(quote_id)
      if(email_log.length > 0) {
        await this.$refs.viewSalesQuoteEmailLogPopUp.openPopup(email_log, quote_code, true, quote_id, customer_id)
      } else {
        await this.fetchCustomerListForSend(quote_id, customer_id)
      }
    },
    async fetchCustomerListForSend(quote_id, customer_id) {
      try {
        this.selected_quote_id = quote_id
        const { data } = (await DropDownRepository.getCustomerUsersDropdownList(customer_id)).data
        this.customer_users_list = data
      } catch (e) {

      }
      this.activeEmailSelectPrompt = true
    },
    async fetchEmailLog(id) {
      await this.$vs.loading({
        container: '#customer-product-orders-table',
        scale: 0.45
      })
      try {
        const { data } = (await CustomerRepository.getListOfSalesQuoteEmailLog(id)).data
        this.$vs.loading.close('#customer-product-orders-table > .con-vs-loading')
        return data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#customer-product-orders-table > .con-vs-loading')
    },
    async onClickViewSalesQuoteEmailLog(id, quote_code) {
      const email_log = await this.fetchEmailLog(id)
      await this.$refs.viewSalesQuoteEmailLogPopUp.openPopup(email_log, quote_code)
    },
    onClickPrintQuote(id, customer_id, quote_code) {
      this.$refs.salesQuotePrintView.openPopup(id, customer_id, quote_code)
      // let routeData = this.$router.resolve({name:'sales-quote-print-view', params:{id:id}})
      // window.open(routeData.href,'_blank');
    },
    onClickViewSampleOrder(id){
      this.$router.push({path: `/pages/sample-orders/${id}`})
    },
    viewSalesQuote(id){
      this.$refs.viewSalesQuotePopUp.openPopup(id)
    },
    async onClickSendQuote() {
      await this.$vs.loading({
        container: '#customer-product-orders-table',
        scale: 0.45
      })
      try {
        this.activeEmailSelectPrompt = false
        await CustomerRepository.sendSalesQuote(this.selected_quote_id, { user_email: this.customer_email })
        this.selected_quote_id = ''
        this.customer_email = ''
        this.showSuccessMessage('Sales quote sent successfully')
        await this.fetchSalesQuoteList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#customer-product-orders-table > .con-vs-loading')
    },
    async refreshData() {
      this.is_on_create = false
      this.customerId = this.$route.params.id ? this.$route.params.id : null
      await this.fetchSalesQuoteList()
    },
    changeStatus() {
      this.is_on_create = true
    },
    editSalesQuote(data){
      this.$router.push({path: `/pages/sales-quote/${data.id}/update`})
    },
    onSelectCustomer(data) {
      this.account_currency = data.account_currency || this.account_currency
      this.customerId = data.id
    },
    async fetchSalesQuoteList() {
      await this.$vs.loading()
      try {
        let data = {}
        if(!!this.customerId) {
          data = (await CustomerRepository.getListOfSalesQuoteWithCustomer(this.customerId, this.page, this.filterQuery, this.perPage, this.sort)).data
        } else {
          data = (await CustomerRepository.getListOfSalesQuote(this.page, this.filterQuery, this.perPage, this.sort)).data
        }
        this.sales_quote_list = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchCustomerList() {
      await this.$vs.loading({
        container: '#customer-product-orders-table',
        scale: 0.45
      })
      try {
        const { data } = await DropDownRepository.getCustomersList()
        this.customer_list = data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#customer-product-orders-table > .con-vs-loading')
    },
    async onChangeStatus(status, id) {
      await this.$vs.loading({
        container: '#customer-product-orders-table',
        scale: 0.45
      })
      try {
        await CustomerRepository.salesQuoteStatusChange(id, status)
        this.showSuccessMessage('Sales quote status changed successfully')
        await this.fetchSalesQuoteList()
      } catch (error) {
        this.convertAndNotifyError(error);
      }
      this.$vs.loading.close('#customer-product-orders-table > .con-vs-loading')
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    filterQueryUpdate (){
      this.fetchSalesQuoteList()
    },

    handleChangePage(page) {
      this.page=page;
      this.fetchSalesQuoteList()
    },
  },
  watch : {
    page(){
      this.fetchSalesQuoteList()
    },
    perPage() {
      this.fetchSalesQuoteList()
    }
  },
}
</script>

<style scoped>

</style>
